import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/Originals.css';

const Originals = () => {
  return (
    <>
      <Helmet>
        <title>Originals - Exclusive Content & Documentaries | Redbox Global</title>
        <meta name="description" content="Watch exclusive Redbox Global original content, documentaries, investigative series, and premium video features covering business, technology, and global affairs." />
        <meta name="keywords" content="original content, documentaries, exclusive videos, investigative journalism, premium content, business documentaries, tech series, video journalism" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/originals" />
        <meta property="og:title" content="Originals - Exclusive Content & Documentaries | Redbox Global" />
        <meta property="og:description" content="Watch exclusive Redbox Global original content, documentaries, and investigative series." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/originals" />
        <meta name="twitter:title" content="Originals - Exclusive Content & Documentaries | Redbox Global" />
        <meta name="twitter:description" content="Watch exclusive Redbox Global original content, documentaries, and investigative series." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/originals" />
      </Helmet>
      
      <div className="page-container">
        <div className="page-header">
          <h1>Originals</h1>
          <p className="page-subtitle">Exclusive documentaries, investigative series, and premium original content</p>
        </div>
        
        <div className="page-content">
          <a href="/article/silicon-valley-behind-scenes" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="featured-article">
              <div className="featured-image">
                <img src="https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=1200&h=600&fit=crop" alt="Documentary production" />
              </div>
              <div className="featured-content">
                
                <h2>Silicon Valley: Behind the Curtain</h2>
                <p>An exclusive 6-part documentary series exploring the untold stories of tech giants, startup culture, and the people shaping our digital future. Go beyond the headlines with unprecedented access.</p>
                <span className="article-meta">New Series • 6 Episodes</span>
              </div>
            </div>
          </a>

          <div className="content-grid">
            <a href="/article/climate-crisis-investigative-series" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1611270629569-8b357cb88da9?w=600&h=400&fit=crop" alt="Climate investigation" />
                </div>
                <div className="article-content">
                  
                  <h2>The Climate Crisis: Follow the Money</h2>
                  <p>An investigative deep dive into climate finance, green investments, and corporate accountability.</p>
                  <span className="article-meta">Feature Documentary</span>
                </div>
              </article>
            </a>

            <a href="/article/future-of-ai-documentary" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&h=400&fit=crop" alt="AI documentary" />
                </div>
                <div className="article-content">
           
                  <h2>AI Revolution: Machines, Minds, and Morality</h2>
                  <p>Exploring the ethical implications and transformative power of artificial intelligence.</p>
                  <span className="article-meta">3-Part Series</span>
                </div>
              </article>
            </a>

            <a href="/article/global-power-shifts" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&h=400&fit=crop" alt="Global affairs" />
                </div>
                <div className="article-content">
                
                  <h2>Power Shift: Geopolitics in the 21st Century</h2>
                  <p>An original series examining the changing balance of global power and influence.</p>
                  <span className="article-meta">Documentary Series</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Originals;
